import WatchListAdd from "../../../components/watch-list/watch-list-add";
import Page from "../../page";

const WatchListAddPage = () => {
  return (
    <Page>
      <WatchListAdd />
    </Page>
  );
};

export default WatchListAddPage;
